function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// handle time, day, or custom format
var monthAbbrev = {
  January: 'Jan.',
  February: 'Feb.',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'Aug.',
  September: 'Sept.',
  October: 'Oct.',
  November: 'Nov.',
  December: 'Dec.'
};

exports.DateFormatHandler = function (date, type, customOptions) {
  var enUS = 'en-us';
  var dateFormat = new Date(date);
  var options = customOptions;
  var format;

  switch (type) {
    case 'time':
      options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'America/Los_Angeles'
      };
      format = dateFormat.toLocaleTimeString(enUS, options);
      break;

    case 'date':
      options = {
        weekday: 'short',
        month: 'long',
        day: 'numeric'
      };
      format = dateFormat.toLocaleString(enUS, options); // Handle case of Tuesday

      if (format.includes('Tue')) format = format.replace('Tue', 'Tues'); // Handle case of Thursday

      if (format.includes('Thu')) format = format.replace('Thu', 'Thurs'); // Handle abbreviation of months

      Object.entries(monthAbbrev).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            month = _ref2[0],
            abbr = _ref2[1];

        if (format.includes(month)) format = format.replace(month, abbr);
        return format;
      });
      break;

    case 'day':
      options = {
        day: 'numeric'
      };
      format = dateFormat.toLocaleDateString(enUS, options);
      break;

    case 'monthDay':
      options = {
        month: 'numeric',
        day: 'numeric'
      };
      format = dateFormat.toLocaleDateString(enUS, options);
      break;

    case 'custom':
      format = dateFormat.toLocaleDateString(enUS, options);
      break;

    default:
      options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'America/Los_Angeles'
      };
      format = dateFormat.toLocaleTimeString(enUS, options);
  }

  return format.replace(/^0(?:0:0?)?/, '');
};